import axios from "axios";
import React, { useEffect, useState } from "react";
import { showSuccess, showError } from "component/utils/SweetAlert";

const UserForm = ({ mode, userData, closeModal, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: "",
    jabatan: "",
    username: "",
    password: "",
  });

  useEffect(() => {
    if (mode === "edit" && userData) {
      setFormData((prev) => ({ ...prev, ...userData }));
    } else {
      setFormData({ name: "", jabatan: "", username: "", password: "" });
    }
  }, [mode, userData]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const formDataToSend = {
      real_name: formData.name,
      jabatan: formData.jabatan,
      user_id: formData.username,
      pwd: formData.password,
    };
  
    if (mode === "edit" && !formData.password) {
      delete formDataToSend.pwd;
    }
  
    try {
      const response = await axios({
        method: mode === "add" ? "POST" : "PUT",
        url:
          mode === "add"
            ? `${process.env.REACT_APP_API}/user`
            : `${process.env.REACT_APP_API}/user/${userData.username}`,
        data: formDataToSend,
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (response.status === 200 || response.status === 201) {
        showSuccess(mode === "add" ? "User berhasil ditambahkan" : "User berhasil diperbarui");
        closeModal();
        if (onSuccess) onSuccess();
      } else {
        showError(mode === "add" ? "Gagal menambahkan user" : "Gagal memperbarui User");
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menyimpan data.");
    }
  };
  

  return (        
    <>
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{mode === "add" ? "Tambah User" : "Edit User"}</h5>
          <button type="button" className="btn-close" onClick={closeModal}></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div class="form-group mb-3">
              <label for="username" class="form-label">Username</label>
              <input 
                class="form-control"
                type="text" 
                name="username"
                placeholder="Isi Username"
                value={formData.username}
                readOnly={mode === "edit"}
                onChange={handleChange}
                required
              />
            </div>
            <div class="form-group mb-3">
              <label for="name" class="form-label">Nama Lengkap</label>
              <input 
                class="form-control"
                type="text" 
                name="name"
                placeholder="Isi Nama Lengkap"
                value={formData.name}
                readOnly={mode === "edit"}
                onChange={handleChange}
                required
              />
            </div>
            <div class="form-group mb-3">
              <label for="jabatan" class="form-label">Pilih Jabatan</label>
              {mode === "edit" ? (
                // Mode Edit: Tidak menampilkan "Pilih Jabatan", langsung opsi jabatan yang sesuai
                <select className="form-select" name="jabatan" value={formData.jabatan} onChange={handleChange} required>
                  <option value={formData.jabatan}>{formData.jabatan.charAt(0).toUpperCase() + formData.jabatan.slice(1)}</option>
                  <option value="pimpinan">Pimpinan</option>
                  <option value="marketing">Marketing</option>
                  <option value="admin">Admin</option>
                  <option value="superadmin">Superadmin</option>
                </select>
              ) : (
                // Mode Tambah: Ada opsi "Pilih Jabatan"
                <select className="form-select" name="jabatan" value={formData.jabatan} onChange={handleChange} required>
                  <option value="" hidden>Pilih Jabatan</option>
                  <option value="SUPERADMIN">SUPERADMIN</option>
                  <option value="PIMPINAN">PIMPINAN</option>
                  <option value="MARKETING">MARKETING</option>
                  <option value="ADMIN">ADMIN</option>
                </select>
              )}
            </div>
            <div class="form-group mb-3">
              <label for="password" class="form-label">Password</label>
              <input 
                class="form-control"
                type="password" 
                name="password"
                value={formData.password}
                onChange={handleChange}
                required={mode === "add"}
                placeholder={mode === "add" ? "Isi Password" : "Biarkan kosong jika tidak ingin diubah"}
              />
            </div>
            <button type="submit" class="btn btn-primary">
              {mode === "add" ? "Save" : "Update"}
            </button>
          </form>
          
        </div>
      </div>
    </div>
    </>
  );
};

export default UserForm;
